<template>
    <div>
        <b-row class="mb-3">
            <b-col><span class="h3">Rates Tables</span></b-col>
            <b-col class="text-right">
                <b-button variant="primary" v-b-modal.addItemTable-modal>Add Override Table <i class="ml-1 fa-regular fa-table"></i></b-button>
            </b-col>
        </b-row>
        <template v-for="(item, metal, index) in ratesByMetal">
            <b-card v-if="index != 9" header-bg-variant="dark">
                <template v-slot:header>
                    <span class="h5 mb-0">{{ metal | titleCase }} </span>
                </template>
                <b-row>
                    <b-col :cols="getBaseColumns(item)">
                        <cardTable
                                :hasOverrides="hasOverrides(item)"
                                :title="'base'"
                                :item="item.base"
                                :name="metal"
                                :index="index"
                                :saving="saving"
                                @openDeletedTier="openDeletedTier"
                                @addTier="addTier"
                                @cancelEdits="cancelEdits"
                                @saveEdits="saveEdits">
                        </cardTable>
                    </b-col>

                    <template v-if="item.overrides">
                        <b-col cols="6" v-for="(item, name, index) in item.overrides" :key="index">
                            <cardTable :title="name"
                                       :item="item"
                                       :metal="metal"
                                       :name="name"
                                       :index="index"
                                       :saving="saving"
                                       @openDeletedTier="openDeletedTier"
                                       @addTier="addTier"
                                       @cancelEdits="cancelEdits"
                                       @saveEdits="saveEdits">

                            </cardTable>
                        </b-col>
                    </template>

                </b-row>
            </b-card>
        </template>


        <!-- Add Item Table -->
        <b-modal size="lg" ref="addItemTable-modal" id="addItemTable-modal" title="Add Override Table">
            <b-container fluid>

                <b-row>
                    <b-col>
                        <b-card header="Metal and Item Type">
                            <b-row>
                                <b-col>
                                    <label for="">Metal Type</label>
                                    <b-select size="sm"
                                              v-model="addTable.metalSelected"
                                              :options="addTable.metalOptions">
                                    </b-select>
                                </b-col>
                                <b-col>
                                    <label for="">Item Category</label>
                                    <b-select size="sm"
                                              :disabled="addTable.metalSelected == null"
                                              v-model="addTable.categorySelected"
                                              :options="addTable.categoryOptions">
                                    </b-select>
                                </b-col>
                                <b-col>
                                    <label for="">Item Type <i>(optional)</i></label>
                                    <b-select size="sm"
                                              :disabled="addTable.categorySelected == null"
                                              v-model="addTable.itemTypeSelected"
                                              :options="addTable.itemTypeOptions">
                                    </b-select>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-card header="Level 1 Payout Rate Details">
                            <b-row>
                                <b-col>
                                    <label for="">Max DWT</label>
                                    <b-input size="sm" v-model="addTable.rule"></b-input>
                                </b-col>
                                <b-col>
                                    <label for="">Payout Percentage</label>
                                    <b-input size="sm" v-model="addTable.percentage"></b-input>
                                </b-col>
                                <b-col>
                                    <label for="">Description</label>
                                    <b-input size="sm" v-model="addTable.description"></b-input>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
            <template #modal-footer="{}">
                <b-button @click="closeAddOverrideModal">Cancel <i class="fa-regular fa-times"></i></b-button>
                <b-button variant="primary" @click="addOverrideRate">Add Override <i v-if="!saving" class="fa-regular fa-plus"></i> <i v-else class="fa-regular fa-spin fa-spinner" ></i> </b-button>
            </template>
        </b-modal>


        <b-modal id="confirm-tier-delete">
            <div class="d-block text-center" v-if="itemToDelete">
                Are you sure you want to delete tier from <b>{{ itemToDelete.item.name}} - {{ itemToDelete.title | titleCase}}</b> table?
            </div>

            <template #modal-footer="{}">
                <b-button small  @click="$bvModal.hide('confirm-tier-delete')">Cancel</b-button>
                <b-button small variant="danger" @click="deleteTableTier(itemToDelete.item,itemToDelete.title )">Delete Tier <i v-if="isDeleting" class="fa-regular fa-spin fa-spinner"></i> </b-button>
            </template>

        </b-modal>


    </div>
</template>

<script>
    import _ from 'lodash';
    import cardTable from './card-table';
    export default {
        name: 'rates-table-view',
        components: {
            cardTable,
        },
        data() {
            return {
                saving: false,
                isSaving: {},
                isDeleting: false,
                itemClasses: null,
                itemTypes: null,
                itemCategories: null,
                payoutRates: null,
                cachePayoutRates: null,
                ratesByMetal: null,
                itemToDelete: null,
                itemsToDeleteStorage: [],
                addTable: {
                    rule: null,
                    percentage: null,
                    description: null,
                    itemTypeSelected: null,
                    metalSelected: null,
                    categorySelected: null,
                    categoryOptions: [{value: null, text: 'Select Option',disabled: true}],
                    metalOptions: [{value: null, text: 'Select Option',disabled: true}],
                    itemTypeOptions: [{value: null, text: 'Select Option',disabled: true}],
                },
            }
        },
        created() {
            this.getAllData();
        },
        watch: {
            // updates the item types select dropdown in the Add Override modal based on the item category selected
            'addTable.categorySelected'() {
                if(this.addTable.categorySelected) {
                    this.addTable.itemTypeSelected = null;
                    let categoryId = this.addTable.categorySelected;
                    let category = this.itemCategories.filter(item => (item.id == categoryId) ? item : '' );
                    let categoryItems = category[0].types;
                    let b = categoryItems.map( item => ({value: item.id, text: item.name}))
                    this.addTable.itemTypeOptions.length = 1;
                    this.addTable.itemTypeOptions.push(...b);
                }
            },
        },
        methods: {
            createRatesTables() {
                let payload = {};
                let that = this;
                this.itemClasses.forEach( function (_class) {
                    let arrByMetal = that.payoutRates.filter( rate => rate.item_class_id == _class.id);
                    if(arrByMetal.length > 0) {
                        let base = arrByMetal.filter( a => a.item_category_id == null );
                        let overrides = arrByMetal.filter( b => b.item_category_id != null );
                        payload[_class.name] = {};
                        payload[_class.name]['base'] = base;
                        payload[_class.name]['overrides'] = _.groupBy(overrides, function (n) {
                            if(n.item_type_id == null) {
                                let name = that.itemCategories.filter( item => item.id == n.item_category_id);
                                return name[0].name;
                            } else {
                                let name = that.itemTypes.filter( item => item.id == n.item_type_id)
                                return name[0].name;
                            }

                        });
                    }
                });

                for (const property in payload) {
                    payload[property].base.sort( function (a, b) {
                        return a.max_dwt - b.max_dwt;
                    });

                    if(!_.isEmpty(payload[property].overrides) ) {
                        for(let itemType in payload[property].overrides) {
                            payload[property].overrides[itemType].sort( function (a, b) {
                                return a.max_dwt - b.max_dwt;
                            })
                        }
                    }
                }
                this.ratesByMetal = payload;
            },

            getBaseColumns(item) {
                return _.isEmpty(item.overrides) ? 12 : 6
            },
            hasOverrides(item) {
                return _.isEmpty(item.overrides) ? 'light' : 'secondary';
            },

            // processes the ratesByMetal object back into payoutRates array we can send to DB
            updatePayoutRates() {
                let payload = [];
                let that = this;
                _.forEach(this.ratesByMetal, function(value, key) {
                    _.forEach(that.ratesByMetal[key], function(value2,key2) {
                        if(key2 == 'base') {
                            payload.push(...value2)
                        } else {
                            _.forEach(that.ratesByMetal[key][key2], function (value3) {
                                payload.push(...value3)
                            })
                        }
                    });
                });
                this.payoutRates = payload;
                this.$forceUpdate()
            },

            addTier(payload, title, name, metal) {
                console.log('payload', payload);
                console.log('title', title);
                console.log('name', name);
                console.log('metal', metal);

                if(payload.level != null) {
                    if(title == 'base') {
                        this.ratesByMetal[name]['base'].splice((payload.level - 1), 0 , payload);
                    } else {
                        this.ratesByMetal[metal]['overrides'][name].splice((payload.level - 1), 0 , payload);
                    }
                }
                this.updatePayoutRates();
            },

            openDeletedTier(item, title) {
                console.log('item to delete1: ',item.item);
                console.log('title1', title);
                this.itemToDelete = {
                    title: title,
                    item: item.item,
                }
                this.$bvModal.show('confirm-tier-delete');


//                this.deleteTableTier(this.itemToDelete.item,this.itemToDelete.title )
            },

            deleteTableTier(item, title) {
                this.isDeleting = true;
//                console.log('item to delete2: ',item);
                this.itemsToDeleteStorage.push(item);
                let className = this.itemClasses.filter(_class => _class.id == item.item_class_id);
//                console.log(className[0].name);
//                console.log('title2', title);

                if(item.item_category_id == null) {
//                    console.log(this.ratesByMetal[className[0].name].base);
                    this.ratesByMetal[className[0].name].base = this.ratesByMetal[className[0].name].base.filter(_item => _item.id != item.id)
                } else {
                    this.ratesByMetal[className[0].name].overrides[title] = this.ratesByMetal[className[0].name].overrides[title].filter(_item => _item.id != item.id)
                }

                this.$http.delete('/payout-rates/' + item.id).then(response => {
//                    console.log(response);
                    this.$nextTick(() => {
                        this.payoutRates = response.data.data;
//                        this.saveEdits();
                        this.createRatesTables();
                        this.$bvModal.hide('confirm-tier-delete');
                        this.isDeleting = false;

                    })
                })
            },


            cancelEdits() {
                this.payoutRates = JSON.parse(JSON.stringify(this.cachePayoutRates));
                if(this.itemsToDeleteStorage.length > 0) {
                    this.saveEdits();
                } else {
                    this.createRatesTables();
                    this.$forceUpdate();

                    // to close edit mode
                    this.saving = true;
                    let that = this;
                    setTimeout(function() {
                        that.saving = false;
                    }, 200);

                }
            },

            saveEdits() {
                this.cachePayoutRates = JSON.parse(JSON.stringify(this.payoutRates));
                this.saving = true;
                this.$http.post('/payout-rates', {rates: this.payoutRates} )
                        .then(response => {
                    console.log(response);
                    this.payoutRates = response.data.data;
                    this.createRatesTables();

                    // this accounts for a few different ways saveEdits can be called
                    this.$nextTick(() => {
                        this.$refs["addItemTable-modal"].hide();
                        this.$bvModal.hide('confirm-tier-delete');
                        this.clearAddTableSelects();
                        this.isDeleting = false;
                        this.saving = false;
                        this.itemsToDeleteStorage = [];
                    })
                });
            },



            closeAddOverrideModal() {
                this.$refs["addItemTable-modal"].hide();
                this.clearAddTableSelects()
            },
            clearAddTableSelects() {
                this.addTable.metalSelected = null;
                this.addTable.itemTypeSelected = null;
                this.addTable.categorySelected = null;
                this.addTable.rule = null;
                this.addTable.description = null;
                this.addTable.percentage = null;
            },

            addOverrideRate() {
                let classID = this.addTable.metalSelected;
                let className = this.itemClasses.filter(item => item.id == classID);
                className = className[0].name;
                className = className[0].toUpperCase() + className.slice(1);

                let payload = {
                    level: 1,
                    id: null,
                    max_dwt: this.addTable.rule,
                    description:this.addTable.description,
                    item_class_id:this.addTable.metalSelected,
                    item_category_id:this.addTable.categorySelected,
                    item_type_id:this.addTable.itemTypeSelected,
                    amount:this.addTable.percentage,
                    amount_type: '%',
                    name: className,
                }
                this.payoutRates.push(payload);
                this.saveEdits();

            },





            getAllData() {
                let that = this;
                this.$http.all([
                    this.$http.get('/payout-rates'),
                    this.$http.get('/items/classes'),
                    this.$http.get('/items/categories'),
                    this.$http.get('/items/types'),
                ]).then(this.$http.spread(function (response1, response2, response3, response4) {
                    that.payoutRates = response1.data.data;
                    that.itemClasses = response2.data.data;
                    that.itemCategories = response3.data.data;
                    that.itemTypes = response4.data.data;
                    that.cachePayoutRates = JSON.parse(JSON.stringify(that.payoutRates));

                    that.createRatesTables();

                    that.$nextTick(() => {
                        let classes = that.itemClasses.map( item => ({value: item.id, text: item.name }) );
                        that.addTable.metalOptions.push(...classes);

                        let categories = that.itemCategories.map( item => ({value: item.id, text: item.name }) );
                        that.addTable.categoryOptions.push(...categories);

                        let types = that.itemTypes.map( item => ({value: item.id, text: item.name }) );
                        that.addTable.itemTypeOptions.push(...types);
                    });
                }))
            },
        },
    };
</script>

<style scoped>

</style>
